export default function initCategoriesHome() {
    const sliderElement = document.querySelector('.c-categories__slider');
    const containerElement = document.querySelector('.c-categories'); // Usado para buscar as setas em segurança

    if (!sliderElement || !containerElement) return;

    const prevButton = containerElement.querySelector('.c-categories__nav--prev');
    const nextButton = containerElement.querySelector('.c-categories__nav--next');

    const catSwiper = new Swiper(sliderElement, {
        slidesPerView: 'auto', // O tamanho é lido do nosso CSS (208px e 290px)
        spaceBetween: 20, // Espaço entre os cards no mobile
        loop: true,

        effect: 'creative',
        creativeEffect: {
            limitProgress: 8,
            prev: {
                shadow: true,
                translate: [0, 0, -400],
                opacity: 0,
            },
            next: {
                translate: ['calc(100% + 20px)', 0, 0],
            },
        },

        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },

        breakpoints: {
            992: {
                spaceBetween: 30, // Espaço no desktop
            }
        },

        a11y: {
            prevSlideMessage: 'Categorias anteriores',
            nextSlideMessage: 'Próximas categorias',
        }
    });
}